import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import ToggleEntities from "./components/ToggleEntities";
import { Submissions, Jobs, NotesPerJob, Contracts, SubmissionHistory } from "./sections";
import { SECTIONS } from "./types";

import styles from "./BullhornDashboard.module.css";

const SectionsMap = {
  contracts: <Contracts />,
  notes: <NotesPerJob />,
  submissions: <Submissions />,
  submissionHistory: <SubmissionHistory />,
  jobs: <Jobs />
};

const BullhornDashboard = () => {
  const [currentSection, setCurrentSection] = useState(SECTIONS.Jobs);

  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const section = queryParams.get("section");

  useEffect(() => {
    setCurrentSection(section);
  }, [section]);

  const handleChangeSection = (newSection) => {
    setCurrentSection(newSection);
    queryParams.set("section", newSection);
    history.push({
      pathname: location.pathname,
      search: queryParams.toString()
    });
  };

  return (
    <div className={styles.wrapper}>
      <h2>BullhornDashboard</h2>

      <ToggleEntities currentSection={currentSection} setCurrentSection={handleChangeSection} />

      {SectionsMap[currentSection]}
    </div>
  );
};

export { BullhornDashboard };
